import { useSubscription } from 'urql';
import { graphql } from '../lib/graphql';
import { useOrg } from '../hooks/use-org';

const BusinessHoursSubscription = graphql(`
  subscription WidgetBusinessHours($organizationId: Uuid!) {
    businessHours(where: { organizationId: { _eq: $organizationId } }, orderBy: { createdAt: ASC }) {
      id
      name
    }
  }
`);

export function useBusinessHours() {
  const { organizationId } = useOrg();

  const [{ data }] = useSubscription({
    query: BusinessHoursSubscription,
    variables: { organizationId: organizationId ?? '' },
    pause: !organizationId,
  });

  return data?.businessHours;
}
